import type { ReactElement } from 'react'
import { Link, Outlet, useLocation } from 'react-router-dom'

/**
 * 整屏布局契约：占满视口高度、全程不产生整页滚动，游戏页只在自己的 main 里滚动。
 * 游戏视图依赖 main 的 flex-1 + min-h-0 + overflow-hidden 来撑满剩余空间。
 *
 * 根节点带安全区内边距（配合 index.html 的 viewport-fit=cover）：
 * 避免底部的聊天输入框被 iOS 手势条盖住、横屏时内容被刘海遮住。桌面端 env() 为 0，行为不变。
 */
export function App(): ReactElement {
  const { pathname } = useLocation()
  const atLobby = pathname === '/'

  return (
    <div className="flex h-dvh flex-col overflow-hidden pb-[env(safe-area-inset-bottom)] pl-[env(safe-area-inset-left)] pr-[env(safe-area-inset-right)]">
      <header className="shrink-0 border-b border-white/10 bg-black/20">
        <div className="mx-auto flex w-full max-w-5xl items-center justify-between gap-3 px-3 py-3 sm:px-4">
          <Link to="/" className="text-lg font-semibold text-white no-underline hover:text-accent">
            游戏平台
          </Link>
          {atLobby ? null : (
            <Link to="/" className="text-sm text-white/70 no-underline hover:text-accent">
              ← 返回大厅
            </Link>
          )}
        </div>
      </header>
      <main id="app-main" className="flex min-h-0 flex-1 flex-col overflow-hidden">
        <Outlet />
      </main>
    </div>
  )
}
